import { AbunanceSelection } from '@resistapp/client/data-utils/filter-data/filter';
import type { User } from '@resistapp/common/types';
import { isResistomapAdminUser } from './access';

export const adminHeatmapAbundanceOptions = Object.freeze([
  AbunanceSelection.ANALYSED,
  AbunanceSelection.MEASURED_OR_ESTIMATE,
  AbunanceSelection.ESTIMATES,
]);

const adminHeatmapAbundanceOptionSet = new Set<AbunanceSelection>(adminHeatmapAbundanceOptions);

export function canUseResearchHeatmapGeneSetSelector(
  user: User | undefined | null,
  isAdminModeActive: boolean,
): boolean {
  return isAdminModeActive && isResistomapAdminUser(user);
}

export function getEffectiveResearchHeatmapAbundanceMode(
  selectedMode: AbunanceSelection,
  canUseSelector: boolean,
): AbunanceSelection {
  if (!canUseSelector) {
    return AbunanceSelection.ANALYSED;
  }

  return adminHeatmapAbundanceOptionSet.has(selectedMode) ? selectedMode : AbunanceSelection.ANALYSED;
}

export function requiresResearchHeatmapEstimationsParam(mode: AbunanceSelection): boolean {
  return mode === AbunanceSelection.MEASURED_OR_ESTIMATE || mode === AbunanceSelection.ESTIMATES;
}
